import { useGenericSocket } from "@/hooks/useGenericSocket.ts";
import { SocketTopics } from "@/lib/natsConnection.ts";
import { merge } from "lodash";
import { useCallback } from "react";
import { environment } from "@/lib/constants.ts";

export interface IManipulation {
  corr: number;
  corrV: number;
}

interface IManipulationMonitorResponse {
  timestamp: number;
  data: Record<string, IManipulation>;
}

export interface IManipulationFlat {
  symbol: string;
  corr: number;
  corrV: number;
}

export function useManipulationMonitor() {
  const handler = useCallback(
    (
      _: IManipulationFlat[],
      newData: IManipulationMonitorResponse,
    ): IManipulationFlat[] => {
      if (!newData?.data) {
        return [];
      }

      return Object.entries(newData.data).map(([symbol, data]) => ({
        symbol,
        corr: ((1 - data.corr) * 100) / 2,
        corrV: ((1 - data.corrV) * 100) / 2,
      }));
    },
    [],
  );

  return useGenericSocket<IManipulationFlat[], IManipulationMonitorResponse>(
    SocketTopics.dictManipulationMonitors,
    handler,
  );
}
